import React from 'react';

interface ColorPickerProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
}

const ColorPicker: React.FC<ColorPickerProps> = ({ label, value, onChange, ...props }) => {
   const labelStyle: React.CSSProperties = {
    display: 'block',
    color: '#94a3b8',
    marginBottom: '0.5rem',
    fontSize: '0.875rem',
  };
   const colorInputStyle: React.CSSProperties = {
    width: '100%',
    height: '40px',
    border: '1px solid #334155',
    borderRadius: '0.375rem',
    cursor: 'pointer',
    background: 'transparent',
  };
  return (
    <div style={{ marginBottom: '1rem' }} {...props}>
      <label style={labelStyle}>{label}</label>
      <input 
        type="color" 
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{...colorInputStyle, backgroundColor: value }}
      />
    </div>
  );
}

export default ColorPicker; 